require('./zipcode-changer.scss');

var zcEventHandler = require('./zipcode-changer-event-handler');

var zipcodeChangerForm = $('form[name="zipcode-changer-form"]');
var zipcodeChanger = $('.gw-zipcode-changer .zipcode-toggle');

zipcodeChangerForm.each(function(index, zipcodeForm) {
    var $zipcodeForm = $(zipcodeForm),
        $geolocation = $zipcodeForm.siblings('.zipcode-changer-geolocation'),
        $input = $zipcodeForm.find('input[name="zip"]');
    $geolocation.on('click', function(e) {
        e.preventDefault();
        zcEventHandler.geolocation($zipcodeForm, $input);
    });

    $zipcodeForm.on('submit', zcEventHandler.submit);
});

zipcodeChanger.on('click', zcEventHandler.zipToggler);


//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/zipcode-changer/zipcode-changer.js
// module id = 114
// module chunks = 0 1 16 24 25